// African countries (and key diaspora regions) most relevant to the Tsoro
// mancala family. Used for the registration country selector and to map
// to a default ruleset on the user's profile.

export const COUNTRY_LIST = [
  { code: "ZW", name: "Zimbabwe", ruleset: "zimbabwe-standard" },
  { code: "MZ", name: "Mozambique", ruleset: "mozambique-ntxuva" },
  { code: "ZM", name: "Zambia", ruleset: "zambia-malawi-nsolo" },
  { code: "MW", name: "Malawi", ruleset: "zambia-malawi-nsolo" },
  { code: "ZA", name: "South Africa", ruleset: "south-africa-moruba" },
  { code: "UG", name: "Uganda", ruleset: "uganda-omweso" },
  { code: "RW", name: "Rwanda", ruleset: "uganda-omweso" },
  { code: "BI", name: "Burundi", ruleset: "uganda-omweso" },
  { code: "TZ", name: "Tanzania", ruleset: "bao" },
  { code: "KE", name: "Kenya", ruleset: "kenya-mbothe" },
  { code: "GH", name: "Ghana", ruleset: "ghana-oware" },
  { code: "NG", name: "Nigeria", ruleset: "nigeria-ayo" },
  { code: "CI", name: "Côte d'Ivoire", ruleset: "ghana-oware" },
  { code: "CV", name: "Cape Verde", ruleset: "ghana-oware" },
  { code: "ET", name: "Ethiopia", ruleset: "zimbabwe-standard" },
  { code: "CD", name: "Democratic Republic of the Congo", ruleset: "uganda-omweso" },
  { code: "EG", name: "Egypt", ruleset: "zimbabwe-standard" },
  { code: "BW", name: "Botswana", ruleset: "south-africa-moruba" },
  { code: "NA", name: "Namibia", ruleset: "south-africa-moruba" },
  { code: "AO", name: "Angola", ruleset: "mozambique-ntxuva" },
  { code: "GB", name: "United Kingdom (diaspora)", ruleset: "zimbabwe-standard" },
  { code: "US", name: "United States (diaspora)", ruleset: "ghana-oware" },
  { code: "CA", name: "Canada (diaspora)", ruleset: "zimbabwe-standard" },
  { code: "CARIB", name: "Caribbean diaspora", ruleset: "ghana-oware" },
  { code: "OTHER", name: "Other / not listed", ruleset: "zimbabwe-standard" },
];

export function rulesetForCountry(code) {
  const c = COUNTRY_LIST.find((x) => x.code === code);
  return c ? c.ruleset : "zimbabwe-standard";
}
